'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_640a77b2 = {"container":"DateInput_module_container__23d7f6fa","calendar-wrapper":"DateInput_module_calendarWrapper__23d7f6fa"};
require("../../../assets/cjs/components/DateInput/src/DateInput~DI-TrJoH.css");

exports.default = modules_640a77b2;
//# sourceMappingURL=DateInput.module.less.js.map
